var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8127 2.468L9.5322 0.187359C9.41241 0.0673394 9.24978 0 9.08012 0C8.91046 0 8.74804 0.0673394 8.62805 0.187359L1.08263 7.73262C1.00504 7.81 0.948991 7.90591 0.919149 8.0112L0.0239246 11.1871C-0.0387369 11.4098 0.0237283 11.6489 0.187401 11.8126C0.308895 11.9341 0.472175 12 0.63948 12C0.697233 12 0.75564 11.9921 0.812772 11.9761L3.98868 11.0809C4.09417 11.0511 4.19011 10.9948 4.26746 10.9174L11.8127 3.37217C12.0625 3.12255 12.0625 2.71756 11.8127 2.468ZM3.48136 9.89517L1.56455 10.4353L2.10487 8.5189L9.08012 1.5438L10.4564 2.92007L3.48136 9.89517Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00781 7.71095L1.10352 8.61523L3.38383 10.8955L4.28813 9.99123L2.00781 7.71095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.b3e0c22c3ee0781cd9ee7c0ea593d6e2.svg";
export { ForwardRef as ReactComponent };